@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_844_394_223)
internal val Res.string.intro_msg_8: StringResource by lazy {
      StringResource("string:intro_msg_8", "intro_msg_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172256, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169644, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171263, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163168, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159348, 63),
      ))
    }

@delegate:ResourceContentHash(1_929_439_163)
internal val Res.string.intro_msg_9: StringResource by lazy {
      StringResource("string:intro_msg_9", "intro_msg_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172328, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169708, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171327, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163236, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159412, 43),
      ))
    }

@delegate:ResourceContentHash(1_289_365_668)
internal val Res.string.intro_notifications_granted: StringResource by lazy {
      StringResource("string:intro_notifications_granted", "intro_notifications_granted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172372, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169756, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171367, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163280, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159456, 71),
      ))
    }

@delegate:ResourceContentHash(535_777_324)
internal val Res.string.intro_timer_granted: StringResource by lazy {
      StringResource("string:intro_timer_granted", "intro_timer_granted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172448, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169832, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171443, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163348, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159528, 51),
      ))
    }

@delegate:ResourceContentHash(-421_884_875)
internal val Res.string.intro_title: StringResource by lazy {
      StringResource("string:intro_title", "intro_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172500, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169896, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171499, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163404, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159580, 35),
      ))
    }

@delegate:ResourceContentHash(-729_327_101)
internal val Res.string.investiga_btn: StringResource by lazy {
      StringResource("string:investiga_btn", "investiga_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172536, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169936, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171535, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163440, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159616, 37),
      ))
    }

@delegate:ResourceContentHash(140_243_221)
internal val Res.string.label_determinativo: StringResource by lazy {
      StringResource("string:label_determinativo", "label_determinativo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172574, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169970, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171569, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163474, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159654, 47),
      ))
    }

@delegate:ResourceContentHash(-830_722_294)
internal val Res.string.label_gardiner_code: StringResource by lazy {
      StringResource("string:label_gardiner_code", "label_gardiner_code", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172622, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170018, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171617, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163522, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159702, 47),
      ))
    }

@delegate:ResourceContentHash(126_094_732)
internal val Res.string.label_ideogramma: StringResource by lazy {
      StringResource("string:label_ideogramma", "label_ideogramma", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172670, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170070, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171665, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163574, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159750, 36),
      ))
    }

@delegate:ResourceContentHash(685_063_046)
internal val Res.string.label_meaning: StringResource by lazy {
      StringResource("string:label_meaning", "label_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172711, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170111, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171710, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163615, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159787, 33),
      ))
    }

@delegate:ResourceContentHash(-2_033_035_995)
internal val Res.string.label_pronunciation: StringResource by lazy {
      StringResource("string:label_pronunciation", "label_pronunciation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172749, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170149, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171752, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163653, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159821, 63),
      ))
    }

@delegate:ResourceContentHash(-141_529_330)
internal val Res.string.label_reading: StringResource by lazy {
      StringResource("string:label_reading", "label_reading", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172809, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170213, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171820, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163717, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159885, 45),
      ))
    }

@delegate:ResourceContentHash(-141_529_330)
internal val Res.string.label_transliteration: StringResource by lazy {
      StringResource("string:label_transliteration", "label_transliteration", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172855, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170259, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171870, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163763, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159931, 53),
      ))
    }

@delegate:ResourceContentHash(-1_439_514_663)
internal val Res.string.label_variants: StringResource by lazy {
      StringResource("string:label_variants", "label_variants", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173187, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170595, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172242, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164083, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160243, 34),
      ))
    }

@delegate:ResourceContentHash(824_397_640)
internal val Res.string.label_variants_disclaimer: StringResource by lazy {
      StringResource("string:label_variants_disclaimer", "label_variants_disclaimer", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172909, 277),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170313, 281),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171928, 313),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163817, 265),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159985, 257),
      ))
    }

@delegate:ResourceContentHash(1_764_018_582)
internal val Res.string.language_desc: StringResource by lazy {
      StringResource("string:language_desc", "language_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173226, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170634, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172281, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164118, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160278, 65),
      ))
    }

@delegate:ResourceContentHash(1_476_808_121)
internal val Res.string.language_title: StringResource by lazy {
      StringResource("string:language_title", "language_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173284, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170700, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172351, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164188, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160344, 34),
      ))
    }

@delegate:ResourceContentHash(1_336_271_758)
internal val Res.string.lesson_aggettivi_genere_desc: StringResource by lazy {
      StringResource("string:lesson_aggettivi_genere_desc", "lesson_aggettivi_genere_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173319, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170731, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172382, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164219, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160379, 92),
      ))
    }

@delegate:ResourceContentHash(1_476_864_292)
internal val Res.string.lesson_aggettivi_genere_title: StringResource by lazy {
      StringResource("string:lesson_aggettivi_genere_title", "lesson_aggettivi_genere_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173412, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170824, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172479, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164308, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160472, 69),
      ))
    }

@delegate:ResourceContentHash(-1_534_047_727)
internal val Res.string.lesson_aggettivi_plurale_desc: StringResource by lazy {
      StringResource("string:lesson_aggettivi_plurale_desc", "lesson_aggettivi_plurale_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173482, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170886, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172537, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164366, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160542, 81),
      ))
    }

@delegate:ResourceContentHash(-427_201_491)
internal val Res.string.lesson_aggettivi_plurale_title: StringResource by lazy {
      StringResource("string:lesson_aggettivi_plurale_title", "lesson_aggettivi_plurale_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173564, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 170972, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172631, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164448, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160624, 58),
      ))
    }

@delegate:ResourceContentHash(-2_103_208_619)
internal val Res.string.lesson_aggettivo_sostantivato_desc: StringResource by lazy {
      StringResource("string:lesson_aggettivo_sostantivato_desc", "lesson_aggettivo_sostantivato_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173619, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171031, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172702, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164507, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160683, 98),
      ))
    }

@delegate:ResourceContentHash(562_574_339)
internal val Res.string.lesson_aggettivo_sostantivato_title: StringResource by lazy {
      StringResource("string:lesson_aggettivo_sostantivato_title", "lesson_aggettivo_sostantivato_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173714, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171122, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172801, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164598, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160782, 79),
      ))
    }

@delegate:ResourceContentHash(-1_843_920_319)
internal val Res.string.lesson_apposizione_desc: StringResource by lazy {
      StringResource("string:lesson_apposizione_desc", "lesson_apposizione_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173790, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171194, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172869, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164670, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160862, 107),
      ))
    }

@delegate:ResourceContentHash(397_607_989)
internal val Res.string.lesson_apposizione_title: StringResource by lazy {
      StringResource("string:lesson_apposizione_title", "lesson_apposizione_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173930, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171314, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 172985, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164790, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160970, 48),
      ))
    }

@delegate:ResourceContentHash(-824_511_939)
internal val Res.string.lesson_cambio_di_rotta_desc: StringResource by lazy {
      StringResource("string:lesson_cambio_di_rotta_desc", "lesson_cambio_di_rotta_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 173979, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171363, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173034, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164839, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161019, 67),
      ))
    }

@delegate:ResourceContentHash(1_359_562_016)
internal val Res.string.lesson_cambio_di_rotta_title: StringResource by lazy {
      StringResource("string:lesson_cambio_di_rotta_title", "lesson_cambio_di_rotta_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174055, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171431, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173102, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164911, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161087, 60),
      ))
    }

@delegate:ResourceContentHash(2_043_042_313)
internal val Res.string.lesson_cartigli_desc: StringResource by lazy {
      StringResource("string:lesson_cartigli_desc", "lesson_cartigli_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174108, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171488, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173163, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 164968, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161148, 120),
      ))
    }

@delegate:ResourceContentHash(376_889_593)
internal val Res.string.lesson_cartigli_title: StringResource by lazy {
      StringResource("string:lesson_cartigli_title", "lesson_cartigli_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174249, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171613, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173300, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165093, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161269, 45),
      ))
    }

@delegate:ResourceContentHash(1_573_188_467)
internal val Res.string.lesson_chap1_chat_desc: StringResource by lazy {
      StringResource("string:lesson_chap1_chat_desc", "lesson_chap1_chat_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174295, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171655, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173346, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165135, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161315, 94),
      ))
    }

@delegate:ResourceContentHash(-1_448_602_263)
internal val Res.string.lesson_chap1_chat_title: StringResource by lazy {
      StringResource("string:lesson_chap1_chat_title", "lesson_chap1_chat_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174374, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171746, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173445, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165226, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161410, 55),
      ))
    }

@delegate:ResourceContentHash(-6_264_962)
internal val Res.string.lesson_chap2_e_ora_desc: StringResource by lazy {
      StringResource("string:lesson_chap2_e_ora_desc", "lesson_chap2_e_ora_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174422, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171798, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173505, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165274, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161466, 111),
      ))
    }

@delegate:ResourceContentHash(1_002_984_408)
internal val Res.string.lesson_chap2_e_ora_title: StringResource by lazy {
      StringResource("string:lesson_chap2_e_ora_title", "lesson_chap2_e_ora_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174534, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171918, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173633, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165382, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161578, 44),
      ))
    }

@delegate:ResourceContentHash(1_612_830_183)
internal val Res.string.lesson_classi_verbali_desc: StringResource by lazy {
      StringResource("string:lesson_classi_verbali_desc", "lesson_classi_verbali_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174583, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171967, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173686, 110),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165423, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161623, 90),
      ))
    }

@delegate:ResourceContentHash(-1_404_962_349)
internal val Res.string.lesson_classi_verbali_title: StringResource by lazy {
      StringResource("string:lesson_classi_verbali_title", "lesson_classi_verbali_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174690, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172074, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173797, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165526, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161714, 55),
      ))
    }

@delegate:ResourceContentHash(-1_558_429_452)
internal val Res.string.lesson_complementi_complessi_desc: StringResource by lazy {
      StringResource("string:lesson_complementi_complessi_desc", "lesson_complementi_complessi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174746, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172130, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173857, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165582, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161770, 97),
      ))
    }

@delegate:ResourceContentHash(153_328_204)
internal val Res.string.lesson_complementi_complessi_title: StringResource by lazy {
      StringResource("string:lesson_complementi_complessi_title", "lesson_complementi_complessi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174860, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172244, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 173955, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165688, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161868, 62),
      ))
    }

@delegate:ResourceContentHash(-2_070_174_077)
internal val Res.string.lesson_complemento_oggetto_desc: StringResource by lazy {
      StringResource("string:lesson_complemento_oggetto_desc", "lesson_complemento_oggetto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 174927, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172319, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174022, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165759, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161931, 79),
      ))
    }

@delegate:ResourceContentHash(638_044_674)
internal val Res.string.lesson_complemento_oggetto_title: StringResource by lazy {
      StringResource("string:lesson_complemento_oggetto_title", "lesson_complemento_oggetto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175015, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172407, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174098, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165847, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162011, 60),
      ))
    }

@delegate:ResourceContentHash(1_412_229_456)
internal val Res.string.lesson_due_oggetti_desc: StringResource by lazy {
      StringResource("string:lesson_due_oggetti_desc", "lesson_due_oggetti_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175076, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172476, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174155, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 165916, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162072, 91),
      ))
    }

@delegate:ResourceContentHash(-1_359_669_548)
internal val Res.string.lesson_due_oggetti_title: StringResource by lazy {
      StringResource("string:lesson_due_oggetti_title", "lesson_due_oggetti_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175160, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172564, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174243, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166000, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162164, 48),
      ))
    }

@delegate:ResourceContentHash(-355_448_214)
internal val Res.string.lesson_due_soggetti_desc: StringResource by lazy {
      StringResource("string:lesson_due_soggetti_desc", "lesson_due_soggetti_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175209, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172613, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174292, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166049, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162213, 80),
      ))
    }

@delegate:ResourceContentHash(1_070_769_880)
internal val Res.string.lesson_due_soggetti_title: StringResource by lazy {
      StringResource("string:lesson_due_soggetti_title", "lesson_due_soggetti_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175298, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172694, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174377, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166138, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162294, 49),
      ))
    }

@delegate:ResourceContentHash(-46_337_550)
internal val Res.string.lesson_ecco_fatto_desc: StringResource by lazy {
      StringResource("string:lesson_ecco_fatto_desc", "lesson_ecco_fatto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175352, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172744, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174427, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166188, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162344, 66),
      ))
    }

@delegate:ResourceContentHash(1_050_986_472)
internal val Res.string.lesson_ecco_fatto_title: StringResource by lazy {
      StringResource("string:lesson_ecco_fatto_title", "lesson_ecco_fatto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175419, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172815, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174494, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166255, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162411, 43),
      ))
    }

@delegate:ResourceContentHash(2_114_203_809)
internal val Res.string.lesson_end_verb_1_desc: StringResource by lazy {
      StringResource("string:lesson_end_verb_1_desc", "lesson_end_verb_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175467, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172859, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174542, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166303, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162455, 74),
      ))
    }

@delegate:ResourceContentHash(-627_545_898)
internal val Res.string.lesson_end_verb_1_title: StringResource by lazy {
      StringResource("string:lesson_end_verb_1_title", "lesson_end_verb_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175550, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172938, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174625, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166382, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162530, 51),
      ))
    }

@delegate:ResourceContentHash(-1_956_731_324)
internal val Res.string.lesson_ending_vso_desc: StringResource by lazy {
      StringResource("string:lesson_ending_vso_desc", "lesson_ending_vso_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175598, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172990, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174669, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166434, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162582, 102),
      ))
    }

@delegate:ResourceContentHash(326_602_173)
internal val Res.string.lesson_ending_vso_title: StringResource by lazy {
      StringResource("string:lesson_ending_vso_title", "lesson_ending_vso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175705, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173105, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174768, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166537, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162685, 55),
      ))
    }

@delegate:ResourceContentHash(-1_384_624_099)
internal val Res.string.lesson_eureka_desc: StringResource by lazy {
      StringResource("string:lesson_eureka_desc", "lesson_eureka_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175769, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173161, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174828, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166593, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162741, 98),
      ))
    }

@delegate:ResourceContentHash(1_058_141_678)
internal val Res.string.lesson_eureka_title: StringResource by lazy {
      StringResource("string:lesson_eureka_title", "lesson_eureka_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175880, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173280, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174943, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166696, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162840, 39),
      ))
    }

@delegate:ResourceContentHash(1_420_820_820)
internal val Res.string.lesson_facciamo_il_punto_desc: StringResource by lazy {
      StringResource("string:lesson_facciamo_il_punto_desc", "lesson_facciamo_il_punto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175920, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173320, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 174983, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166736, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162880, 77),
      ))
    }

@delegate:ResourceContentHash(137_665_261)
internal val Res.string.lesson_facciamo_il_punto_title: StringResource by lazy {
      StringResource("string:lesson_facciamo_il_punto_title", "lesson_facciamo_il_punto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176014, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173402, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175069, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166822, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162958, 54),
      ))
    }

@delegate:ResourceContentHash(-492_406_447)
internal val Res.string.lesson_famous_names_desc: StringResource by lazy {
      StringResource("string:lesson_famous_names_desc", "lesson_famous_names_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176073, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173465, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175132, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 166885, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163013, 108),
      ))
    }

@delegate:ResourceContentHash(-128_617_117)
internal val Res.string.lesson_famous_names_title: StringResource by lazy {
      StringResource("string:lesson_famous_names_title", "lesson_famous_names_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176210, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173586, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175261, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167002, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163122, 49),
      ))
    }

@delegate:ResourceContentHash(619_934_081)
internal val Res.string.lesson_filler_a_capo_complementi_desc: StringResource by lazy {
      StringResource("string:lesson_filler_a_capo_complementi_desc", "lesson_filler_a_capo_complementi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176264, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173640, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175315, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167052, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163172, 145),
      ))
    }

@delegate:ResourceContentHash(1_896_164_188)
internal val Res.string.lesson_filler_a_capo_complementi_title: StringResource by lazy {
      StringResource("string:lesson_filler_a_capo_complementi_title", "lesson_filler_a_capo_complementi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176430, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173794, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175493, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167190, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163318, 78),
      ))
    }

@delegate:ResourceContentHash(2_014_200_612)
internal val Res.string.lesson_formare_verbi_desc: StringResource by lazy {
      StringResource("string:lesson_formare_verbi_desc", "lesson_formare_verbi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176517, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 173881, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175584, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167261, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163397, 109),
      ))
    }

@delegate:ResourceContentHash(-1_246_264_385)
internal val Res.string.lesson_formare_verbi_title: StringResource by lazy {
      StringResource("string:lesson_formare_verbi_title", "lesson_formare_verbi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176639, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174003, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175702, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167383, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163507, 50),
      ))
    }

@delegate:ResourceContentHash(-105_904_200)
internal val Res.string.lesson_frasi_avverbiali_desc: StringResource by lazy {
      StringResource("string:lesson_frasi_avverbiali_desc", "lesson_frasi_avverbiali_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176690, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174054, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175753, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167434, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163558, 80),
      ))
    }

@delegate:ResourceContentHash(-1_341_712_250)
internal val Res.string.lesson_frasi_avverbiali_title: StringResource by lazy {
      StringResource("string:lesson_frasi_avverbiali_title", "lesson_frasi_avverbiali_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176779, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174135, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175834, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167519, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163639, 65),
      ))
    }

@delegate:ResourceContentHash(-270_338_169)
internal val Res.string.lesson_frasi_con_pronomi_desc: StringResource by lazy {
      StringResource("string:lesson_frasi_con_pronomi_desc", "lesson_frasi_con_pronomi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176837, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174209, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175900, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167585, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163705, 85),
      ))
    }

@delegate:ResourceContentHash(663_215_242)
internal val Res.string.lesson_frasi_con_pronomi_title: StringResource by lazy {
      StringResource("string:lesson_frasi_con_pronomi_title", "lesson_frasi_con_pronomi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176923, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174299, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175994, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167663, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163791, 70),
      ))
    }

@delegate:ResourceContentHash(-837_550_735)
internal val Res.string.lesson_frasi_con_soggetto_desc: StringResource by lazy {
      StringResource("string:lesson_frasi_con_soggetto_desc", "lesson_frasi_con_soggetto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 176990, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174370, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176061, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167726, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163862, 102),
      ))
    }

@delegate:ResourceContentHash(-1_696_478_058)
internal val Res.string.lesson_frasi_con_soggetto_title: StringResource by lazy {
      StringResource("string:lesson_frasi_con_soggetto_title", "lesson_frasi_con_soggetto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177093, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174477, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176168, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167829, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163965, 71),
      ))
    }

@delegate:ResourceContentHash(-1_653_247_766)
internal val Res.string.lesson_genitivo_diretto_2_desc: StringResource by lazy {
      StringResource("string:lesson_genitivo_diretto_2_desc", "lesson_genitivo_diretto_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177157, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174545, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176232, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 167893, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164037, 98),
      ))
    }

@delegate:ResourceContentHash(1_972_747_867)
internal val Res.string.lesson_genitivo_diretto_2_title: StringResource by lazy {
      StringResource("string:lesson_genitivo_diretto_2_title", "lesson_genitivo_diretto_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177260, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174656, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176339, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168000, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164136, 63),
      ))
    }

@delegate:ResourceContentHash(693_054_164)
internal val Res.string.lesson_genitivo_diretto_desc: StringResource by lazy {
      StringResource("string:lesson_genitivo_diretto_desc", "lesson_genitivo_diretto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177328, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174724, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176403, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168068, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164200, 124),
      ))
    }

@delegate:ResourceContentHash(-1_235_727_601)
internal val Res.string.lesson_genitivo_diretto_title: StringResource by lazy {
      StringResource("string:lesson_genitivo_diretto_title", "lesson_genitivo_diretto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177457, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174849, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176524, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168193, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164325, 57),
      ))
    }

@delegate:ResourceContentHash(1_854_692_529)
internal val Res.string.lesson_genitivo_indiretto_2_desc: StringResource by lazy {
      StringResource("string:lesson_genitivo_indiretto_2_desc", "lesson_genitivo_indiretto_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177519, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174911, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176582, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168255, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164383, 132),
      ))
    }

@delegate:ResourceContentHash(-1_194_779_285)
internal val Res.string.lesson_genitivo_indiretto_2_title: StringResource by lazy {
      StringResource("string:lesson_genitivo_indiretto_2_title", "lesson_genitivo_indiretto_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177660, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175048, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176719, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168380, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164516, 69),
      ))
    }

@delegate:ResourceContentHash(-374_524_428)
internal val Res.string.lesson_genitivo_indiretto_desc: StringResource by lazy {
      StringResource("string:lesson_genitivo_indiretto_desc", "lesson_genitivo_indiretto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177730, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175118, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176789, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168450, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164586, 126),
      ))
    }

@delegate:ResourceContentHash(-1_241_796_117)
internal val Res.string.lesson_genitivo_indiretto_title: StringResource by lazy {
      StringResource("string:lesson_genitivo_indiretto_title", "lesson_genitivo_indiretto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177849, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175245, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176920, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168577, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164713, 67),
      ))
    }

@delegate:ResourceContentHash(-1_236_704_592)
internal val Res.string.lesson_hiero_animals_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_animals_desc", "lesson_hiero_animals_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 177917, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175313, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 176988, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168645, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164781, 121),
      ))
    }

@delegate:ResourceContentHash(1_479_435_488)
internal val Res.string.lesson_hiero_animals_title: StringResource by lazy {
      StringResource("string:lesson_hiero_animals_title", "lesson_hiero_animals_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178039, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175439, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177110, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168759, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164903, 58),
      ))
    }

@delegate:ResourceContentHash(996_990_847)
internal val Res.string.lesson_hiero_dei_sovrani_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_dei_sovrani_desc", "lesson_hiero_dei_sovrani_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178098, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175498, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177169, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168818, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164962, 105),
      ))
    }

@delegate:ResourceContentHash(-631_449_479)
internal val Res.string.lesson_hiero_dei_sovrani_title: StringResource by lazy {
      StringResource("string:lesson_hiero_dei_sovrani_title", "lesson_hiero_dei_sovrani_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178224, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175624, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177303, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 168928, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165068, 78),
      ))
    }

@delegate:ResourceContentHash(271_837_726)
internal val Res.string.lesson_hiero_famiglia_societa_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_famiglia_societa_desc", "lesson_hiero_famiglia_societa_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178319, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175711, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177394, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169003, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165147, 118),
      ))
    }

@delegate:ResourceContentHash(-1_591_421_121)
internal val Res.string.lesson_hiero_famiglia_societa_title: StringResource by lazy {
      StringResource("string:lesson_hiero_famiglia_societa_title", "lesson_hiero_famiglia_societa_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178462, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175842, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177537, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169122, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165266, 79),
      ))
    }

@delegate:ResourceContentHash(129_621_140)
internal val Res.string.lesson_hiero_food_2_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_food_2_desc", "lesson_hiero_food_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178550, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175922, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177621, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169202, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165346, 112),
      ))
    }

@delegate:ResourceContentHash(-380_565_575)
internal val Res.string.lesson_hiero_food_2_title: StringResource by lazy {
      StringResource("string:lesson_hiero_food_2_title", "lesson_hiero_food_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178691, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176063, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177762, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169323, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165459, 53),
      ))
    }

@delegate:ResourceContentHash(226_555_841)
internal val Res.string.lesson_hiero_food_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_food_desc", "lesson_hiero_food_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178749, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176121, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177828, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169377, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165513, 102),
      ))
    }

@delegate:ResourceContentHash(-1_622_818_245)
internal val Res.string.lesson_hiero_food_title: StringResource by lazy {
      StringResource("string:lesson_hiero_food_title", "lesson_hiero_food_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178868, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176252, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177951, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169488, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165616, 51),
      ))
    }

@delegate:ResourceContentHash(733_585_321)
internal val Res.string.lesson_hiero_humans_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_humans_desc", "lesson_hiero_humans_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 178924, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176308, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178011, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169540, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165668, 108),
      ))
    }

@delegate:ResourceContentHash(-1_402_148_732)
internal val Res.string.lesson_hiero_humans_title: StringResource by lazy {
      StringResource("string:lesson_hiero_humans_title", "lesson_hiero_humans_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179041, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176417, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178120, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169637, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165777, 53),
      ))
    }

@delegate:ResourceContentHash(1_963_685_708)
internal val Res.string.lesson_hiero_oggetti_sacri_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_oggetti_sacri_desc", "lesson_hiero_oggetti_sacri_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179103, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176475, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178178, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169691, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165831, 107),
      ))
    }

@delegate:ResourceContentHash(-2_001_849_833)
internal val Res.string.lesson_hiero_oggetti_sacri_title: StringResource by lazy {
      StringResource("string:lesson_hiero_oggetti_sacri_title", "lesson_hiero_oggetti_sacri_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179219, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176595, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178298, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169795, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165939, 84),
      ))
    }

@delegate:ResourceContentHash(1_863_282_528)
internal val Res.string.lesson_hiero_vari_1_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_vari_1_desc", "lesson_hiero_vari_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179308, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176688, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178383, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169876, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166024, 76),
      ))
    }

@delegate:ResourceContentHash(1_162_021_212)
internal val Res.string.lesson_hiero_vari_1_title: StringResource by lazy {
      StringResource("string:lesson_hiero_vari_1_title", "lesson_hiero_vari_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179401, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176773, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178468, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 169957, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166101, 69),
      ))
    }

@delegate:ResourceContentHash(1_863_282_528)
internal val Res.string.lesson_hiero_vari_2_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_vari_2_desc", "lesson_hiero_vari_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179479, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176851, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178538, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170027, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166171, 76),
      ))
    }

@delegate:ResourceContentHash(1_324_516_252)
internal val Res.string.lesson_hiero_vari_2_title: StringResource by lazy {
      StringResource("string:lesson_hiero_vari_2_title", "lesson_hiero_vari_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179572, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 176936, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178623, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170108, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166248, 69),
      ))
    }

@delegate:ResourceContentHash(-1_176_692_257)
internal val Res.string.lesson_hiero_varie_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_varie_desc", "lesson_hiero_varie_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179654, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177014, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178693, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170182, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166318, 111),
      ))
    }

@delegate:ResourceContentHash(-938_962_356)
internal val Res.string.lesson_hiero_varie_title: StringResource by lazy {
      StringResource("string:lesson_hiero_varie_title", "lesson_hiero_varie_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179786, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177146, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178817, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170306, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166430, 56),
      ))
    }

@delegate:ResourceContentHash(451_766_530)
internal val Res.string.lesson_hiero_verbi_vari_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_verbi_vari_desc", "lesson_hiero_verbi_vari_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179851, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177203, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 178874, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170359, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166487, 116),
      ))
    }

@delegate:ResourceContentHash(1_229_978_543)
internal val Res.string.lesson_hiero_verbi_vari_title: StringResource by lazy {
      StringResource("string:lesson_hiero_verbi_vari_title", "lesson_hiero_verbi_vari_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 179980, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177324, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179011, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170476, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166604, 65),
      ))
    }

@delegate:ResourceContentHash(929_184_052)
internal val Res.string.lesson_hiero_verbs_1_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_1_desc", "lesson_hiero_verbs_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180058, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177390, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179081, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170538, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166670, 121),
      ))
    }

@delegate:ResourceContentHash(-552_744_260)
internal val Res.string.lesson_hiero_verbs_1_title: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_1_title", "lesson_hiero_verbs_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180192, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177520, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179215, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170652, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166792, 54),
      ))
    }

@delegate:ResourceContentHash(876_737_194)
internal val Res.string.lesson_hiero_verbs_2_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_2_desc", "lesson_hiero_verbs_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180251, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177579, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179274, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170707, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166847, 89),
      ))
    }

@delegate:ResourceContentHash(-355_067_074)
internal val Res.string.lesson_hiero_verbs_2_title: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_2_title", "lesson_hiero_verbs_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180341, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177685, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179376, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170817, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166937, 54),
      ))
    }

@delegate:ResourceContentHash(2_015_602_707)
internal val Res.string.lesson_hiero_verbs_3_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_3_desc", "lesson_hiero_verbs_3_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180400, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177744, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179435, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170872, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166992, 101),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString16Resources(map: MutableMap<String, StringResource>) {
  map.put("intro_msg_8", Res.string.intro_msg_8)
  map.put("intro_msg_9", Res.string.intro_msg_9)
  map.put("intro_notifications_granted", Res.string.intro_notifications_granted)
  map.put("intro_timer_granted", Res.string.intro_timer_granted)
  map.put("intro_title", Res.string.intro_title)
  map.put("investiga_btn", Res.string.investiga_btn)
  map.put("label_determinativo", Res.string.label_determinativo)
  map.put("label_gardiner_code", Res.string.label_gardiner_code)
  map.put("label_ideogramma", Res.string.label_ideogramma)
  map.put("label_meaning", Res.string.label_meaning)
  map.put("label_pronunciation", Res.string.label_pronunciation)
  map.put("label_reading", Res.string.label_reading)
  map.put("label_transliteration", Res.string.label_transliteration)
  map.put("label_variants", Res.string.label_variants)
  map.put("label_variants_disclaimer", Res.string.label_variants_disclaimer)
  map.put("language_desc", Res.string.language_desc)
  map.put("language_title", Res.string.language_title)
  map.put("lesson_aggettivi_genere_desc", Res.string.lesson_aggettivi_genere_desc)
  map.put("lesson_aggettivi_genere_title", Res.string.lesson_aggettivi_genere_title)
  map.put("lesson_aggettivi_plurale_desc", Res.string.lesson_aggettivi_plurale_desc)
  map.put("lesson_aggettivi_plurale_title", Res.string.lesson_aggettivi_plurale_title)
  map.put("lesson_aggettivo_sostantivato_desc", Res.string.lesson_aggettivo_sostantivato_desc)
  map.put("lesson_aggettivo_sostantivato_title", Res.string.lesson_aggettivo_sostantivato_title)
  map.put("lesson_apposizione_desc", Res.string.lesson_apposizione_desc)
  map.put("lesson_apposizione_title", Res.string.lesson_apposizione_title)
  map.put("lesson_cambio_di_rotta_desc", Res.string.lesson_cambio_di_rotta_desc)
  map.put("lesson_cambio_di_rotta_title", Res.string.lesson_cambio_di_rotta_title)
  map.put("lesson_cartigli_desc", Res.string.lesson_cartigli_desc)
  map.put("lesson_cartigli_title", Res.string.lesson_cartigli_title)
  map.put("lesson_chap1_chat_desc", Res.string.lesson_chap1_chat_desc)
  map.put("lesson_chap1_chat_title", Res.string.lesson_chap1_chat_title)
  map.put("lesson_chap2_e_ora_desc", Res.string.lesson_chap2_e_ora_desc)
  map.put("lesson_chap2_e_ora_title", Res.string.lesson_chap2_e_ora_title)
  map.put("lesson_classi_verbali_desc", Res.string.lesson_classi_verbali_desc)
  map.put("lesson_classi_verbali_title", Res.string.lesson_classi_verbali_title)
  map.put("lesson_complementi_complessi_desc", Res.string.lesson_complementi_complessi_desc)
  map.put("lesson_complementi_complessi_title", Res.string.lesson_complementi_complessi_title)
  map.put("lesson_complemento_oggetto_desc", Res.string.lesson_complemento_oggetto_desc)
  map.put("lesson_complemento_oggetto_title", Res.string.lesson_complemento_oggetto_title)
  map.put("lesson_due_oggetti_desc", Res.string.lesson_due_oggetti_desc)
  map.put("lesson_due_oggetti_title", Res.string.lesson_due_oggetti_title)
  map.put("lesson_due_soggetti_desc", Res.string.lesson_due_soggetti_desc)
  map.put("lesson_due_soggetti_title", Res.string.lesson_due_soggetti_title)
  map.put("lesson_ecco_fatto_desc", Res.string.lesson_ecco_fatto_desc)
  map.put("lesson_ecco_fatto_title", Res.string.lesson_ecco_fatto_title)
  map.put("lesson_end_verb_1_desc", Res.string.lesson_end_verb_1_desc)
  map.put("lesson_end_verb_1_title", Res.string.lesson_end_verb_1_title)
  map.put("lesson_ending_vso_desc", Res.string.lesson_ending_vso_desc)
  map.put("lesson_ending_vso_title", Res.string.lesson_ending_vso_title)
  map.put("lesson_eureka_desc", Res.string.lesson_eureka_desc)
  map.put("lesson_eureka_title", Res.string.lesson_eureka_title)
  map.put("lesson_facciamo_il_punto_desc", Res.string.lesson_facciamo_il_punto_desc)
  map.put("lesson_facciamo_il_punto_title", Res.string.lesson_facciamo_il_punto_title)
  map.put("lesson_famous_names_desc", Res.string.lesson_famous_names_desc)
  map.put("lesson_famous_names_title", Res.string.lesson_famous_names_title)
  map.put("lesson_filler_a_capo_complementi_desc", Res.string.lesson_filler_a_capo_complementi_desc)
  map.put("lesson_filler_a_capo_complementi_title", Res.string.lesson_filler_a_capo_complementi_title)
  map.put("lesson_formare_verbi_desc", Res.string.lesson_formare_verbi_desc)
  map.put("lesson_formare_verbi_title", Res.string.lesson_formare_verbi_title)
  map.put("lesson_frasi_avverbiali_desc", Res.string.lesson_frasi_avverbiali_desc)
  map.put("lesson_frasi_avverbiali_title", Res.string.lesson_frasi_avverbiali_title)
  map.put("lesson_frasi_con_pronomi_desc", Res.string.lesson_frasi_con_pronomi_desc)
  map.put("lesson_frasi_con_pronomi_title", Res.string.lesson_frasi_con_pronomi_title)
  map.put("lesson_frasi_con_soggetto_desc", Res.string.lesson_frasi_con_soggetto_desc)
  map.put("lesson_frasi_con_soggetto_title", Res.string.lesson_frasi_con_soggetto_title)
  map.put("lesson_genitivo_diretto_2_desc", Res.string.lesson_genitivo_diretto_2_desc)
  map.put("lesson_genitivo_diretto_2_title", Res.string.lesson_genitivo_diretto_2_title)
  map.put("lesson_genitivo_diretto_desc", Res.string.lesson_genitivo_diretto_desc)
  map.put("lesson_genitivo_diretto_title", Res.string.lesson_genitivo_diretto_title)
  map.put("lesson_genitivo_indiretto_2_desc", Res.string.lesson_genitivo_indiretto_2_desc)
  map.put("lesson_genitivo_indiretto_2_title", Res.string.lesson_genitivo_indiretto_2_title)
  map.put("lesson_genitivo_indiretto_desc", Res.string.lesson_genitivo_indiretto_desc)
  map.put("lesson_genitivo_indiretto_title", Res.string.lesson_genitivo_indiretto_title)
  map.put("lesson_hiero_animals_desc", Res.string.lesson_hiero_animals_desc)
  map.put("lesson_hiero_animals_title", Res.string.lesson_hiero_animals_title)
  map.put("lesson_hiero_dei_sovrani_desc", Res.string.lesson_hiero_dei_sovrani_desc)
  map.put("lesson_hiero_dei_sovrani_title", Res.string.lesson_hiero_dei_sovrani_title)
  map.put("lesson_hiero_famiglia_societa_desc", Res.string.lesson_hiero_famiglia_societa_desc)
  map.put("lesson_hiero_famiglia_societa_title", Res.string.lesson_hiero_famiglia_societa_title)
  map.put("lesson_hiero_food_2_desc", Res.string.lesson_hiero_food_2_desc)
  map.put("lesson_hiero_food_2_title", Res.string.lesson_hiero_food_2_title)
  map.put("lesson_hiero_food_desc", Res.string.lesson_hiero_food_desc)
  map.put("lesson_hiero_food_title", Res.string.lesson_hiero_food_title)
  map.put("lesson_hiero_humans_desc", Res.string.lesson_hiero_humans_desc)
  map.put("lesson_hiero_humans_title", Res.string.lesson_hiero_humans_title)
  map.put("lesson_hiero_oggetti_sacri_desc", Res.string.lesson_hiero_oggetti_sacri_desc)
  map.put("lesson_hiero_oggetti_sacri_title", Res.string.lesson_hiero_oggetti_sacri_title)
  map.put("lesson_hiero_vari_1_desc", Res.string.lesson_hiero_vari_1_desc)
  map.put("lesson_hiero_vari_1_title", Res.string.lesson_hiero_vari_1_title)
  map.put("lesson_hiero_vari_2_desc", Res.string.lesson_hiero_vari_2_desc)
  map.put("lesson_hiero_vari_2_title", Res.string.lesson_hiero_vari_2_title)
  map.put("lesson_hiero_varie_desc", Res.string.lesson_hiero_varie_desc)
  map.put("lesson_hiero_varie_title", Res.string.lesson_hiero_varie_title)
  map.put("lesson_hiero_verbi_vari_desc", Res.string.lesson_hiero_verbi_vari_desc)
  map.put("lesson_hiero_verbi_vari_title", Res.string.lesson_hiero_verbi_vari_title)
  map.put("lesson_hiero_verbs_1_desc", Res.string.lesson_hiero_verbs_1_desc)
  map.put("lesson_hiero_verbs_1_title", Res.string.lesson_hiero_verbs_1_title)
  map.put("lesson_hiero_verbs_2_desc", Res.string.lesson_hiero_verbs_2_desc)
  map.put("lesson_hiero_verbs_2_title", Res.string.lesson_hiero_verbs_2_title)
  map.put("lesson_hiero_verbs_3_desc", Res.string.lesson_hiero_verbs_3_desc)
}
